import { Button, TextField, Typography } from '@mui/material'
import { Form, useFormikContext } from 'formik'
import { HelperWrapper } from 'src/components/helper-wrapper'

import { useStyles } from 'src/components/un-sdg/un-sdg-list/styles'
import { IUpdateProductOverrideUrlForm } from 'src/types'

export const UpdateQrLinkForm = () => {
  const classes = useStyles()
  const { values, handleChange, errors, dirty, isSubmitting } =
    useFormikContext<IUpdateProductOverrideUrlForm>()

  return (
    <Form className={classes.formWrapper}>
      <div className={classes.inputsWrapper}>
        <Typography className={classes.title}>
          <HelperWrapper t="qr-code-update-form-title" />
        </Typography>
        <div className={classes.inputsWrapper}>
          <TextField
            autoComplete="off"
            variant="standard"
            id="overrideUrl"
            name="overrideUrl"
            onChange={handleChange}
            type="text"
            label={'URL'}
            value={values.overrideUrl}
            helperText={
              <Typography className={classes.warningText}>
                {errors.overrideUrl && <HelperWrapper t={errors.overrideUrl} />}&nbsp;
              </Typography>
            }
          />
        </div>
      </div>
      <Button
        variant="contained"
        disabled={isSubmitting || !dirty || Object.keys(errors).length > 0}
        type="submit"
      >
        <HelperWrapper t="qr-code-update-form-button" />
      </Button>
    </Form>
  )
}
